import { useMemo } from 'react'
import { useAuth } from '../hooks/useAuth'

/** Один .md файл = один экран. Имена совпадают с backend/docs/user/{role}/ */
const MANAGER_MASTER_RULES = [
  { match: (path) => path === '/' || path === '/dashboard', file: 'home.md', title: 'Главная' },
  {
    match: (path) => path === '/user' || path.startsWith('/user/'),
    file: 'contacts.md',
    title: 'Контакты',
  },
  { match: (path) => path === '/certificate', file: 'certificates.md', title: 'Сертификаты' },
  { match: (path) => path === '/seminar', file: 'seminar-list.md', title: 'Список мероприятий' },
  {
    match: (path) => path === '/seminar/certificate',
    file: 'seminar-participants.md',
    title: 'Участники мероприятия',
  },
  { match: (path) => path === '/seminar/calendar', file: 'seminar-planner.md', title: 'Планер' },
  { match: (path) => path === '/order', file: 'orders.md', title: 'Заказы' },
  {
    match: (path) => path === '/sales/stats',
    file: 'sales-stats.md',
    title: 'Статистика продаж 1С',
  },
]

const MANAGER_INSTRUCTOR_RULES = [
  { match: (path) => path === '/' || path === '/dashboard', file: 'home.md', title: 'Главная' },
  {
    match: (path) => path === '/report/instructor/top',
    file: 'instructor-top.md',
    title: 'Топ инструкторов',
  },
  { match: (path) => path === '/instructors', file: 'instructors.md', title: 'Инструкторы' },
  {
    match: (path) => path === '/user' || path.startsWith('/user/'),
    file: 'contacts.md',
    title: 'Контакты',
  },
  { match: (path) => path === '/certificate', file: 'certificates.md', title: 'Сертификаты' },
  { match: (path) => path === '/seminar', file: 'seminar-list.md', title: 'Список мероприятий' },
  {
    match: (path) => path === '/seminar/certificate',
    file: 'seminar-participants.md',
    title: 'Участники мероприятия',
  },
  { match: (path) => path === '/seminar/calendar', file: 'seminar-planner.md', title: 'Планер' },
  { match: (path) => path === '/resale', file: 'resale-list.md', title: 'Список продаж' },
  {
    match: (path) => path === '/resale/stats',
    file: 'resale-stats.md',
    title: 'Статистика продаж',
  },
  { match: (path) => path === '/order', file: 'orders.md', title: 'Заказы' },
  {
    match: (path) => path === '/sales/stats',
    file: 'sales-stats.md',
    title: 'Статистика продаж 1С',
  },
  {
    match: (path) => path === '/storage' || path.startsWith('/storage/'),
    file: 'storage.md',
    title: 'Личный диск',
  },
]

export const useManagerHelpEntry = (pathname) => {
  const { Roles, checkRoles } = useAuth()
  const isManagerMaster = checkRoles(Roles.MANAGER_MASTER)
  const isManagerInstructor = checkRoles(Roles.MANAGER_INSTRUCTOR)

  return useMemo(() => {
    if (!isManagerMaster && !isManagerInstructor) {
      return null
    }

    const rules = isManagerMaster ? MANAGER_MASTER_RULES : MANAGER_INSTRUCTOR_RULES
    const roleFolder = isManagerMaster ? 'manager-master' : 'manager-instructor'
    const rule = rules.find((r) => r.match(pathname))

    if (!rule) {
      return null
    }

    return {
      title: rule.title,
      url: `/help/${roleFolder}/${rule.file}`,
    }
  }, [pathname, isManagerMaster, isManagerInstructor])
}
